import styled from 'styled-components'

import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'

export const TitleSection = styled(TitleSectionBase)`
    background: ${(props) => props.theme.color[props.mode === 'Light' ? 'white' : 'p600']};
`

export const ItemWrapper = styled.div`
    @media ${(props) => props.theme.query.min.tablet} {
        padding-bottom: 100px;

        .last-item & {
            padding-bottom: 0;
        }
    }
`
